var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48596 13.6676C9.19615 13.6676 10.5767 12.2871 10.5767 10.5769C10.5767 8.86676 9.19615 7.48625 7.48596 7.48625C5.77578 7.48625 4.39526 8.86676 4.39526 10.5769C4.39526 12.2871 5.77578 13.6676 7.48596 13.6676ZM19.8488 7.48625H11.6069V14.6979H3.36503V5.42578H1.30457V20.8793H3.36503V17.7886H21.9092V20.8793H23.9697V11.6072C23.9697 9.33036 22.1256 7.48625 19.8488 7.48625Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.e905b33c5a66a871ee3279507c3dba22.svg";
export { ForwardRef as ReactComponent };